<template>
  <v-application v-if="access.inv_supplier_transaction">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="supplier"
          to="/inventory/supplier/transactions"
          v-bind:headers="headers"
          v-bind:data="supplier_transactions"
          v-bind:remove="remove_suppliers"
          v-bind:num-pages="suppliers_total"
          v-model="suppliers_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_supplier'"
          v-bind:getData="supplierTransactionsGet"
          add
          supplierTransaction
          no-delete
        >
          <template #search>
            <!-- <v-toolbar-title
              >Total balance: {{ total_balance }} Total favor:{{
                total_favor
              }}</v-toolbar-title
            > -->
            <v-spacer />
            <v-combobox
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              outlined
              dense
              item-text="name"
              class="mx-1"
            />
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                autofocus
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), getSuppliers();
                  }
                "
                @change="getSuppliers()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-btn :loading="excel_button" icon @click="downloadSubTran">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
// const PageSuppliers = Object.assign(Suppliers, {
//   mounted(){
//     this.update_suppliers()
//   }
// })
import SupplierTransactions from "../../mixins/inventory/supplier_transaction";
import Userable from "../../mixins/userable";

export default {
  name: "InventorySupplier",
  mixins: [Suppliers, SupplierTransactions, Services, Userable],
  data: () => ({
    search_text: false,
    search: "",
    searchText: "",
    searchService: "",
    page: 1,
    data_loading: false,
    excel_button: false,
  }),
  watch: {
    async suppliers_page() {
      this.data_loading = true;
      this.page = this.suppliers_page;
      await this.supplierTransactionsGet(this.searchText);
      this.data_loading = false;
    },
    searchText() {
      this.supplierTransactionsGet(this.searchText);
    },
  },
  computed: {
    headers() {
      const headers = [
        { text: this.$t("supplier_name"), value: "supplier_name" , available: true},
        { text: this.$t("total_receive"), value: "total_receive", available: true },
        { text: this.$t("total_spend"), value: "total_spend", available: true },
        // { text: this.$t("store"), value: "service_name" },
        // { text: this.$t("balance"), value: "balance" },
      ];
      // if (this.user_access && this.user_access.inv_purchase_orders_cost) {
      //   headers.push({
      //     text: this.$t("total"),
      //     value: "total",
      //     align: "right",
      //   });
      // }
      return headers;
    },
  },
  methods: {
    async downloadSubTran() {
      const exportLink = `supplier-transactions/get/${this.token}/suppliers.xlsx`;
      this.excel_button = true;
      const a = await new Promise((resolve) => {
        resolve(
          this.$communicator.downloadDocumentPost(
            exportLink,
            `suppliers.xls`,
            this.store?._id
          )
        );
      });
      this.excel_button = a;
    },
    async changePagination(page) {
      this.suppliers_page = page;
      const query = {
        ...this.$route.query,
        page: this.suppliers_page,
        search: this.search,
      };
      await this.$router.push({ path: this.$route.path, query: query });
      this.update_suppliers();
    },
    searchActivate() {
      this.search_text = true;
    },
    getSuppliers() {
      const query = {
        ...this.$route.query,
        search: this.search,
        page: this.suppliers_page,
      };
      this.$router.push({ path: this.$route.path, query: query });
      this.searchText = this.search;
    },
  },
  async mounted() {
    const query = this.$route.query;
    if ((query || query.search) && query.page) {
      if (this.search != query.search) {
        this.search = query.search;
        this.suppliers_page = parseInt(query.page);
        this.$router.push({
          path: this.$route.path,
          query: { search: this.search },
        });
        this.search_text = true;
        this.data_loading = true;
        await this.getSuppliers();
        this.data_loading = false;
      } else {
        this.search_text = false;
        this.$router.push({
          path: this.$route.path,
          query: { page: query.page },
        });
        await this.supplierTransactionsGet();
      }
    } else {
      this.data_loading = true;
      await this.supplierTransactionsGet();
      this.data_loading = false;
    }
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },

  beforeMount() {
    this.load_on_mount = false;
    this.access = this.$store.state.access;
  },
};
</script>
